import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePager(items, perPage = 10) {
  const [page, setPage] = useState(1);
  const pages = Math.max(1, Math.ceil(items.length / perPage));
  useEffect(() => { if (page > pages) setPage(pages); }, [pages, page]);
  return { page, pages, setPage, slice: items.slice((page - 1) * perPage, page * perPage) };
}

export function Pager({ page, pages, setPage, testid = "pager" }) {
  if (pages <= 1) return null;
  const btn = "w-8 h-8 rounded-lg border border-white/10 flex items-center justify-center text-white/60 hover:text-red-400 hover:border-red-800/50 disabled:opacity-25 disabled:hover:text-white/60 disabled:hover:border-white/10 transition-colors";
  const start = Math.max(1, Math.min(page - 2, pages - 4));
  const nums = Array.from({ length: Math.min(5, pages) }, (_, i) => start + i);
  return (
    <div className="flex items-center justify-center gap-2 pt-4" data-testid={testid}>
      <button type="button" onClick={() => setPage(page - 1)} disabled={page <= 1} className={btn} data-testid={`${testid}-prev`}><ChevronLeft className="w-4 h-4" /></button>
      {nums.map((n) => (
        <button key={n} type="button" onClick={() => setPage(n)} data-testid={`${testid}-page-${n}`}
          className={`min-w-8 h-8 px-2 rounded-lg font-mono text-xs border transition-colors ${n === page ? "btn-red text-white border-transparent" : "border-white/10 text-white/60 hover:text-red-400 hover:border-red-800/50"}`}>{n}</button>
      ))}
      <button type="button" onClick={() => setPage(page + 1)} disabled={page >= pages} className={btn} data-testid={`${testid}-next`}><ChevronRight className="w-4 h-4" /></button>
    </div>
  );
}
